import Select from "react-select";

const DatosxAdmitidos = ({
  serenos,
  setDocumento,
  funciones,
  setSelectedFuncion,
}) => {
  return (
    <>
      <div
        className="mb-3 divselectpersona"
        style={{
          width: "80%",
          padding: "15px",
          display:'flex',
          justifyContent:'center',
        }}
      >
       
      </div>
      <div
        className="mb-3 divselectpersona"
        style={{
          width: "80%",
          padding: "15px",
        }}
      >
        <label className="form-label">Seleccione la persona:</label>
        <Select
          className="selectpersona"
          options={serenos.map((sereno) => ({
            value: sereno.SERE_P_chDNI,
            label: `( ${sereno.SERE_P_chDNI} ) ${sereno.SERE_APELLNOM}`,
          }))}
          onChange={(selectedOption) => setDocumento(selectedOption.value)}
          isSearchable
          placeholder="Buscar Personal"
        />
      </div>
      <div
        className="mb-3 divselectfuncion"
        style={{
          width: "80%",
          padding: "15px",
          paddingTop: "0px",
        }}
      >
        <label className="form-label">Seleccione su tipo de actividad:</label>
        <Select
          className="selectfuncion"
          options={funciones.map((funcion) => ({
            value: funcion.per_CH_nomParam,
            label: funcion.per_CH_nomParam,
          }))}
          onChange={(selectedOption) =>
            setSelectedFuncion(selectedOption ? selectedOption.value : null)
          }
          isSearchable
          placeholder="Selecciona una actividad"
        />
      </div>
      
    </>
  );
};

export default DatosxAdmitidos;
